export const SAMPLE_PREVIEW_URL = "https://tucatalogo.co";

// El precio vive dentro de `references[0]`, no en la raiz del producto —
// asi lo leen todas las variantes de ProductItem (`resolvedReference.price`),
// igual que un producto real del backend.
export const SAMPLE_PRODUCTS = [
    {
        slug: "sample-1",
        name: "Producto de ejemplo",
        references: [
            {
                price: 35000,
                priceOffer: 0,
                images: [{ url: "/img/default/product_1.webp" }]
            }
        ],
        active: true
    },
    {
        slug: "sample-2",
        name: "Otro producto",
        references: [
            {
                price: 52000,
                priceOffer: 0,
                images: [{ url: "/img/default/product_2.webp" }]
            }
        ],
        active: true
    }
];

export const SAMPLE_SOCIAL_NETWORKS = [
    { network: "instagram", url: SAMPLE_PREVIEW_URL },
    { network: "facebook", url: SAMPLE_PREVIEW_URL }
];

// Numero completo (indicativo + local), mismo formato que guarda
// `whatsappNumber` cuando el cliente escribe uno real — asi
// `buildWhatsappWaMeLink` no necesita distinguir un numero de muestra de uno
// real.
export const SAMPLE_WHATSAPP_NUMBER = "573000000000";

export const SAMPLE_LINKS_SEGMENT = {
    id: "sample-links-segment",
    type: "links",
    style: "block",
    links: [
        {
            id: "sample-link-1",
            url: "#",
            title: "Contáctanos",
            imageUrl: "/img/networks-icons/whatsapp.png"
        }
    ]
};
